import styled from 'styled-components';
import { size } from 'polished';
import { AbstractButton } from '../../atoms/AbstractButton/AbstractButton';
import { typeStyle } from '../../../styles/typeStyle';
import { zIndex } from '../../../styles/zIndex';
import { Ease } from '../../../styles/easing';
import { FontWeight, TransitionDuration } from '../../../styles/variables';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';
import { hover } from '../../../styles/helpers/hover';

export const StyledListViewButton = styled(AbstractButton)`
  ${size('2.5rem')};
  position: absolute;
  bottom: 0.625rem;
  right: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.small};
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.lightBlack};
  z-index: ${zIndex('active-marker')};
  cursor: pointer;
  transition: box-shadow ${TransitionDuration.Slow} ${Ease.EaseOut},
    transform ${TransitionDuration.Slow} ${Ease.EaseOutBack};

  svg {
    ${size('1rem')};
  }

  @media ${respondTo(MediaQuery.Medium)} {
    ${typeStyle.normal};
    font-weight: ${FontWeight.Bold};
    top: 1.25rem;
    right: 1.25rem;
    bottom: auto;
    width: auto;
    white-space: nowrap;
    flex-direction: row-reverse;
    padding: 0 0.6875rem;

    svg {
      margin-right: 0.625rem;
    }
  }

  ${hover(`
      transform: scale(1.03);
      box-shadow: 0 0.25rem 1.25rem rgba(48, 76, 178, 0.2);
  `)}

  &:focus {
    transform: scale(1.04);
    border: 1px solid ${({ theme }) => theme.color.blue};
    box-shadow: 0px 0px 4px ${({ theme }) => theme.color.blue};
  }
`;
